import React, { Component } from "react";
import { Container, Col, Row, Label, Button, FormGroup } from "reactstrap";

import { themeService } from "../../../../theme/service/activeTheme.service";

import { trackReportStyle } from "../style/index";
import "../style/style.css";
import { ruble } from "react-icons-kit/fa/ruble";
import { languageService } from "Language/language.service";
import { checkmark } from "react-icons-kit/icomoon/checkmark";
import SvgIcon from "react-icons-kit";
import _ from "lodash";
//import moment from "moment";
import { iconToShow, iconTwoShow } from "../../variables";
import { SignatureImage, SignatureImageImproved } from "../../utils/SignatureImage";
import ReportTitleSection from "../../../../libraries/ReportGenerator/ReportTitleSection";
import ReportInfoSection from "../../../../libraries/ReportGenerator/ReportInfoSection";
function statusCal(value) {
  let obj = { Good: "G", Satisfactory: "S", Defect: "D" };
  let toRet = obj[value] ? obj[value] : "";
  return toRet;
}
class MonthlyBridgeInspectionView extends Component {
  constructor(props) {
    super(props);

    this.config = {
      minCommentRows: 4,
      minIssueRows: 4,
    };
  }
  render() {
    let bridgeData = [];
    let commentsData = [];
    let rowToFil = null;
    let lang = localStorage.getItem("language");
    let inceaseHeight = lang === "en" ? null : { height: "335px" };
    let commentRowToFill = null;
    if (this.props.assetData && this.props.assetData.form) {
      let data = {};
      this.props.assetData.form.forEach((field) => {
        if (field && field.id) data[field.id] = field.value;
      });
      let roadMaster = { first: "", second: "", third: "" };
      let inspectorWork = {
        corrected: data["li-act"] == "Inspector Corrected" ? "Yes" : "",
        slowOrder: data["li-act"] == "Slow Order" ? "Yes" : "",
        tos: data["li-act"] == "Out of Service" ? "Yes" : "",
      };

      rowToFil = (
        <tr>
          <td colSpan={3}></td>
          <td>{statusCal(data["li-bolt"])}</td>
          <td>{statusCal(data["li-bar"])}</td>
          <td>{statusCal(data["li-rail"])}</td>
          <td>{statusCal(data["li-appro"])}</td>
          <td>{statusCal(data["li-timb"])}</td>
          <td>{statusCal(data["li-plat"])}</td>
          <td>{statusCal(data["li-apar"])}</td>
          <td>{statusCal(data["li-anch"])}</td>
          <td>{statusCal(data["li-rust"])}</td>
          <td>{statusCal(data["li-gaug"])}</td>
          <td>{statusCal(data["li-vege"])}</td>
          <td>{statusCal(data["li-hook"])}</td>
          <td>{statusCal(data["li-rivet"])}</td>
          <td>{statusCal(data["li-not"])}</td>
          <td colSpan={4}>{statusCal(data["li-span"])}</td>
          <td>{inspectorWork.corrected}</td>
          <td>{inspectorWork.slowOrder}</td>
          <td>{inspectorWork.tos}</td>
          <td></td>
          <td>{roadMaster.first}</td>
          <td>{roadMaster.second}</td>
          <td>{roadMaster.third}</td>
        </tr>
      );
      commentRowToFill = (
        <tr>
          <td colSpan={3}></td>
          <td colSpan={18}>{data["tx-comm"]}</td>
          <td colSpan={7}></td>
        </tr>
      );
      bridgeData.push(rowToFil);
    }
    const logo1Source = themeService(iconToShow);
    return (
      <React.Fragment>
        <style
          type="text/css"
          dangerouslySetInnerHTML={{
            __html: "@media print { @page {size: landscape !important;size: auto !important;zoom: 70%}}",
          }}
        />
        <div className="table-report bridge last-page-break-print" style={{ ...themeService(trackReportStyle.mainStyle) }}>
          <ReportTitleSection
            title={languageService("MONTHLY BRIDGE INSPECTION REPORT")}
            {...this.props}
            centerTitle={true}
            fontSizeOverride={"28px"}
          />

          <ReportInfoSection
            centered={true}
            fontSizeOverride={"18px"}
            rows={[
              {
                col1: {
                  title: languageService("Location"),
                  value: this.props.basicData && this.props.basicData.lineName,
                },
                col2: {
                  title: languageService("Asset"),
                  value: this.props.assetData && this.props.assetData.assetName,
                },
              },
              {
                col1: {
                  title: languageService("Mileage"),
                  value: this.props.assetData && this.props.assetData.assetMP,
                },
                col2: {
                  title: languageService("Date"),
                  value: this.props.basicData && this.props.basicData.date,
                },
              },
            ]}
          />
          <span className="spacer"></span>
          <Row>
            <Col md={12}>
              <table>
                <thead>
                  <tr>
                    <th rowSpan="1" colSpan="3"></th>
                    <th rowSpan="1" colSpan="18">
                      {languageService("DEFECT")}: ( {languageService("NOTE")}: "{languageService("G")}" - {languageService("GOOD")} / "
                      {languageService("D")}" -{languageService("DEFECT")} / "{languageService("S")}" - {languageService("SATISFACTORY")} )
                    </th>
                    <th rowSpan="1" colSpan="3">
                      {languageService("ACTION TAKEN BY INSPECTOR")}
                    </th>
                    <th rowSpan="2" colSpan="1" className="table-heading">
                      <span>{languageService("DATE CORRECTED")}</span>
                    </th>
                    <th rowSpan="1" colSpan="3">
                      {languageService("ACTION TAKEN BY ROADMASTER")}
                    </th>
                  </tr>
                  <tr>
                    <th rowSpan="1" colSpan="3" className="main-table-heading">
                      {languageService("LOCATION OF DEFECT")}
                    </th>
                    <th rowSpan="1" colSpan="1" className="table-heading">
                      <span>
                        {languageService("BOLT MISSING")} / {languageService("BROKEN")}
                      </span>
                    </th>
                    <th rowSpan="1" colSpan="1" className="table-heading" style={inceaseHeight}>
                      <span>{languageService("BROKEN JOINT BARS")}</span>
                    </th>
                    <th rowSpan="1" colSpan="1" className="table-heading">
                      <span>{languageService("BROKEN RAIL")}</span>
                    </th>
                    <th rowSpan="1" colSpan="1" className="table-heading">
                      <span>{languageService("APPROACHES")}</span>
                    </th>
                    <th rowSpan="1" colSpan="1" className="table-heading">
                      <span>{languageService("BRIDGE TIMBERS")}</span>
                    </th>
                    <th rowSpan="1" colSpan="1" className="table-heading">
                      <span>{languageService("TIE PLATES")}</span>
                    </th>
                    <th rowSpan="1" colSpan="1" className="table-heading">
                      <span>{languageService("PULL APART")}</span>
                    </th>
                    <th rowSpan="1" colSpan="1" className="table-heading">
                      <span>{languageService("RAIL ANCHORS")}</span>
                    </th>
                    <th rowSpan="1" colSpan="1" className="table-heading">
                      <span>
                        {languageService("RUST")} / {languageService("DEBRIS")}
                      </span>
                    </th>
                    <th rowSpan="1" colSpan="1" className="table-heading">
                      <span>{languageService("WIDE GAUGE")}</span>
                    </th>
                    <th rowSpan="1" colSpan="1" className="table-heading">
                      <span>{languageService("VEGETATION")}</span>
                    </th>
                    <th rowSpan="1" colSpan="1" className="table-heading">
                      <span>{languageService("HOOK BOLTS")}</span>
                    </th>
                    <th rowSpan="1" colSpan="1" className="table-heading">
                      <span>{languageService("RIVETS OR BOLTS")}</span>
                    </th>
                    <th rowSpan="1" colSpan="1" className="table-heading">
                      <span>{languageService("NOT LISTED")}</span>
                    </th>
                    <th rowSpan="1" colSpan="4" className="sub-table-heading">
                      <span>
                        {languageService("OVERALL CONDITION OF BRIDGE INCLUDING")}; {languageService("BOTTOM BRACINGS")};{" "}
                        {languageService("BENTS")}; {languageService("SPANS")} &amp; {languageService("STIFFENERS")}
                      </span>
                    </th>
                    <th rowSpan="1" colSpan="1" className="table-heading">
                      <span>{languageService("INSPECTOR CORRECTED")}</span>
                    </th>
                    <th rowSpan="1" colSpan="1" className="table-heading">
                      <span>{languageService("SLOW ORDER")}</span>
                    </th>
                    <th rowSpan="1" colSpan="1" className="table-heading">
                      <span>{languageService("OUT OF SERVICE")}</span>
                    </th>

                    <th rowSpan="1" colSpan="1" className="table-heading">
                      <span>{languageService("REPORT NOTED")}</span>
                    </th>
                    <th rowSpan="1" colSpan="1" className="table-heading">
                      <span>{languageService("INSPECTED DEFECT")}</span>
                    </th>
                    <th rowSpan="1" colSpan="1" className="table-heading">
                      <span>{languageService("INSPECTED CORRECTIVE A")}</span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {rowToFil}
                  {addEmptyColsIfNotEnough(bridgeData, this.config.minIssueRows, 23, "one")}
                </tbody>
                <thead>
                  <th colSpan="3">{languageService("COMMENTS")}</th>
                  <th colSpan="18"></th>
                  <th colSpan="7"></th>
                </thead>
                <tbody>
                  {commentRowToFill}
                  {addEmptyColsIfNotEnough(bridgeData, this.config.minIssueRows, 3, "two")}
                </tbody>
              </table>
            </Col>
          </Row>
          <ReportInfoSection
            centered={true}
            fontSizeOverride={"18px"}
            rows={[
              {
                col1: {
                  title: languageService("Inspector"),
                  value: this.props.basicData && this.props.basicData.userName,
                },
                col2: {
                  title: languageService("Signature"),
                  value: <SignatureImageImproved signatureImage={this.props.signatureImage} />,
                },
              },
              {
                col1: {
                  title: languageService("Superintendent"),
                  value: "",
                },
              },
            ]}
          />
        </div>
      </React.Fragment>
    );
  }
}

export default MonthlyBridgeInspectionView;

function addEmptyColsIfNotEnough(mapArray, minRows, cols, type) {
  let emptyRows = null;
  let countToAdd = minRows - mapArray.length;
  if (countToAdd > 0) {
    emptyRows = [];
    for (let i = 0; i < countToAdd; i++) {
      let row = <tr>{getCols(cols, type)}</tr>;
      emptyRows.push(row);
    }
  }
  return emptyRows;
}
function getCols(num, type) {
  let cols = [];
  let span = [];
  if (type === "two") span = [3, 18, 7];
  else span = [3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 4, 1, 1, 1, 1, 1, 1, 1];
  for (let i = 0; i < num; i++) {
    cols.push(<td colSpan={span[i]}></td>);
  }
  return cols;
}



// WEBPACK FOOTER //
// ./src/components/Reports/Timps/Bridge/monthlyBridgeInspectionView.jsx